// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__3bgZy","Home":"Index_Home__2DFc4"};